import $ from "jquery";

export default function () {
  const $megamenuContents = $("[data-parent-link]");
  $megamenuContents.each(function (index, megamenuContent) {
    const parentLink = $(megamenuContent).data("parent-link");
    if (parentLink != "") {
      // Desktop nav only: the same menu markup is emitted twice, so an unscoped
      // selector also dropped a copy in the drawer. The drawer uses mobileMenu.js.
      $(".site-header__nav [data-megamenu=" + parentLink + "]")
        .addClass("has-megamenu")
        .append($(megamenuContent).parent().html());
      // $('[data-megamenu=' + parentLink + '] a.m-level-1').addClass('has-plus-icon');
    }
  });

  let hoverTimer;
  $("[data-megamenu].has-megamenu").on("mouseenter", function () {
    clearTimeout(hoverTimer);
    $("body").addClass("megamenu-open");
    $(".menu-overlay").addClass("visible");
  });

  $("[data-megamenu].has-megamenu").on("mouseleave", function () {
    hoverTimer = setTimeout(function () {
      $(".menu-overlay").removeClass("visible");
      $("body").removeClass("megamenu-open");
    }, 0); // Adjust the delay time as needed
  });
}
